module.exports = __webpack_public_path__ + "img/pinch.a6a06dcf.svg";